
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerConeUp as ObiBeaconTowerConeUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-cone-up.js';
 
 
 

 
 export const ObiBeaconTowerConeUp = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-cone-up',
   elementClass: ObiBeaconTowerConeUpElement,
   events: {
     
   }
  });
 
 